module.exports = __webpack_public_path__ + "img/face29.7c84f2fa.gif";